<ph-dialog [open]="open" size="md" heading="How AI chatbot works" (ph-close)="closed.emit()">
    <ph-vertical-stepper static size="lg" current="-1" [items]="steps"></ph-vertical-stepper>
</ph-dialog>
